<template>

    <head>
        <meta charset="utf-8">
        <meta http-equiv="x-ua-compatible" content="ie=edge">
        <title>Edule - eLearning Website Template</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="">
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
        <link rel="shortcut icon" type="image/x-icon" href="/assets/images/favicon.ico">
    </head>

    <!-- Header Section Start -->
    <div class="header-section">

        <!-- Header Top Start -->
        <!-- <div class="header-top d-none d-lg-block">
            <div class="container">
                <div class="header-top-wrapper">
                    <div class="header-top-medal">
                        <div class="top-info">
                            <p><i class="flaticon-email color-white"></i> <a href="mailto:admin@thecolregs.com">admin@thecolregs.com</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- Header Top End -->

        <!-- Header Main Start -->
        <div class="header-main">
            <div class="container">
                <div class="header-main-wrapper">
                    <div class="header-logo">
                        <a href="Home.vue"><img src="/assets/images/logo.png" alt="Logo"></a>
                    </div>

                    <div class="header-menu d-none d-lg-block">
                        <ul class="nav-menu">
                            <li><router-link to="/">Home</router-link></li>
                            <li><router-link to="/about">About Us</router-link></li>
                            <li><router-link to="/packages">Packages</router-link></li>
                            <li><router-link to="/contact">Contact Us</router-link></li>
                            <li><router-link to="/faq">FAQ</router-link></li>
                        </ul>
                    </div>

                    <div class="header-sign-in-up d-none d-lg-block">
                        <span v-if="is_logged_in">
                            <ul>
                                <li><router-link v-if="role === 'admin'" to="/dashboard/admin/home" class="sign-up">Dashboard</router-link></li>
                                <li><router-link v-if="role === 'manager'" to="/dashboard/organization/home" class="sign-up">Dashboard</router-link></li>
                                <li><router-link v-if="role === 'member'" to="/dashboard/user/home" class="sign-up">Dashboard</router-link></li>
                                <li><svg title="logout" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="currentColor" width="28" height="28" @click="logout" class='logout logout-button-pointer'>
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                                </svg></li>
                            </ul>
                        </span>
                        <span v-else>
                            <ul>
                                <li><router-link to="/login" class="sign-in">Login</router-link></li>
                                <li><router-link to="/register" class="sign-up">Register</router-link></li>
                            </ul>
                        </span>
                    </div>

                    <div class="header-toggle d-lg-none">
                        <button 
                            type="button"
                            class="menu-toggle" 
                            @click.stop.prevent="toggleMobileMenu"
                            aria-label="Toggle mobile menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Header Section End -->

    <!-- Backdrop overlay - only shows when menu is open -->
    <div 
        v-if="isMobileMenuOpen" 
        class="mobile-menu-backdrop" 
        @click.stop.prevent="closeMobileMenu"
    ></div>
    
    <!-- Mobile Menu - only shows when open -->
    <transition name="slide">
        <div 
            v-if="isMobileMenuOpen"
            class="mobile-menu menu-open"
        >
            <a class="menu-close" @click.stop.prevent="closeMobileMenu">
                <i class="icofont-close-line"></i>
            </a>

            <div class="mobile-top">
                <p><i class="flaticon-email"></i> <a target="_blank" rel="noopener" :href="'mailto:' + support_email">{{support_email}}</a></p>
            </div>

            <div class="mobile-sign-in-up">
                <span v-if="is_logged_in">
                    <ul>
                        <li><router-link v-if="role === 'admin'" to="/dashboard/admin/home" class="sign-up" @click="closeMobileMenu">Dashboard</router-link></li>
                        <li><router-link v-if="role === 'manager'" to="/dashboard/organization/home" class="sign-up" @click="closeMobileMenu">Dashboard</router-link></li>
                        <li><router-link v-if="role === 'member'" to="/dashboard/user/home" class="sign-up" @click="closeMobileMenu">Dashboard</router-link></li>
                        <li><svg title="logout" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" width="28" height="28" @click="handleLogoutClick" class='logout logout-button-pointer'>
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                        </svg></li>
                    </ul>
                </span>
                <span v-else>
                    <ul>
                        <li><router-link to="/login" class="sign-in" @click="closeMobileMenu">Login</router-link></li>
                        <li><router-link to="/register" class="sign-up" @click="closeMobileMenu">Register</router-link></li>
                    </ul>
                </span>
            </div>

            <div class="mobile-menu-items">
                <ul class="nav-menu">
                    <li><router-link to="/" @click="closeMobileMenu">Home</router-link></li>
                    <li><router-link to="/about" @click="closeMobileMenu">About Us</router-link></li>
                    <li><router-link to="/packages" @click="closeMobileMenu">Packages</router-link></li>
                    <li><router-link to="/contact" @click="closeMobileMenu">Contact Us</router-link></li>
                    <li><router-link to="/faq" @click="closeMobileMenu">FAQ</router-link></li>
                </ul>
            </div>
        </div>
    </transition>
    <!-- Mobile Menu End -->

</template>

<script>
import { jwtDecode } from "jwt-decode";
import {AppConfig} from '@/constants';

export default {
    name: 'AppHeader',
    data() {
        return {
            is_logged_in: false,
            role: null,
            support_email: null,
            isMobileMenuOpen: false  // STARTS CLOSED
        }
    },

    mounted() {
        this.check_if_logged_in();
        this.support_email = AppConfig.SUPPORT_EMAIL;
    },

    watch: {
        '$route': 'check_if_logged_in',
        
        // Add/remove body class for scroll prevention
        isMobileMenuOpen(isOpen) {
            if (isOpen) {
                document.body.classList.add('mobile-menu-open');
            } else {
                document.body.classList.remove('mobile-menu-open');
            }
        }
    },

    methods: {
        check_if_logged_in() {
            const token = localStorage.getItem('access_token');
            if (token) {
                const decoded = jwtDecode(token);
                this.is_logged_in = true;
                this.role = decoded.role;
            } else {
                this.is_logged_in = false;
                this.role = null;
            }
        },

        logout() {
            localStorage.removeItem('access_token');
            this.is_logged_in = false;
            this.role = null;
            this.$router.push({ name: 'Login' });
        },

        toggleMobileMenu() {
            console.log('Toggle clicked. Current state:', this.isMobileMenuOpen);
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            console.log('New state:', this.isMobileMenuOpen);
        },

        closeMobileMenu() {
            console.log('Close clicked. Setting to false');
            this.isMobileMenuOpen = false;
        },

        handleLogoutClick() {
            this.closeMobileMenu();
            this.logout();
        }
    }
};
</script>

<style scoped>
.logout-button-pointer {
    cursor: pointer;
}

.menu-toggle {
    cursor: pointer !important;
    display: inline-block !important;
    padding: 10px !important;
    background: none !important;
    border: none !important;
}

.menu-toggle span {
    display: block !important;
    width: 25px !important;
    height: 3px !important;
    background-color: #333 !important;
    margin: 5px 0 !important;
}

.menu-close {
    cursor: pointer !important;
    font-size: 24px !important;
    padding: 10px !important;
}
</style>

<style>
/* Backdrop - dark overlay behind menu */
.mobile-menu-backdrop {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.5) !important;
    z-index: 9998 !important;
    animation: backdropFadeIn 0.3s ease !important;
}

@keyframes backdropFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Slide transition for mobile menu */
.slide-enter-active {
    transition: transform 0.3s ease-out !important;
}

.slide-leave-active {
    transition: transform 0.3s ease-in !important;
}

.slide-enter-from {
    transform: translateX(100%) !important;
}

.slide-enter-to {
    transform: translateX(0) !important;
}

.slide-leave-from {
    transform: translateX(0) !important;
}

.slide-leave-to {
    transform: translateX(100%) !important;
}

/* Mobile menu panel - OVERRIDE THEME CSS */
.mobile-menu.menu-open {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    left: auto !important; /* Override theme's left positioning */
    width: 280px !important;
    max-width: 85vw !important;
    height: 100vh !important;
    background: #fff !important;
    z-index: 9999 !important;
    overflow-y: auto !important;
    box-shadow: -2px 0 10px rgba(0,0,0,0.3) !important;
    padding: 20px !important;
    padding-top: 70px !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    transform: translateX(0) !important;
}

/* Prevent body scroll when menu open */
body.mobile-menu-open {
    overflow: hidden !important;
}
</style>